import { ClassProvider, Type } from '@angular/core';
import { RouteChangeHandler, ROUTE_CHANGE_HANDLER } from './route-change.handler';

/**
 * A provider used to hook route change handlers into `{@link RouterEventsFacade}`.
 *
 * Prefer using {@link provideRouteChangeHandler} to provide route change handler instead of using this provider directly.
 */
export interface RouteChangeHandlerClassProvider extends ClassProvider {
    useClass: Type<RouteChangeHandler>;
}

/**
 * Creates a strongly-typed provider for route change handler as it is expected by the `{@link RouterEventsFacade}`.
 *
 * @export
 * @param {Type<RouteChangeHandler>} handler The class type implementation for the provider.
 * @return {*}  {RouteChangeHandlerClassProvider}
 */
export function provideRouteChangeHandler(handler: Type<RouteChangeHandler>): RouteChangeHandlerClassProvider {
    return {
        useClass: handler,
        provide: ROUTE_CHANGE_HANDLER,
        multi: true
    } as const;
}
